const KEY = 'sn_orders_v1';

function computeSubtotal(items) {
  return (items || []).reduce((sum, item) => {
    const qty = Number(item.quantity) || 0;
    const price = Number(item.price) || 0;
    return sum + qty * price;
  }, 0);
}

export function computeTotals(order) {
  const subtotal = computeSubtotal(order.items || []);
  const discount = Math.max(0, Number(order.discount) || 0);
  const total = Math.max(0, subtotal - discount);
  return { subtotal, discount, total };
}

function seed() {
  const items = [
    {
      id: 1,
      customerName: 'Ahmed Ali',
      phone: '0300-1234567',
      items: [
        { productId: 1, name: 'Widget A', quantity: 2, price: 9.99 },
        { productId: 2, name: 'Gadget B', quantity: 1, price: 19.5 },
      ],
      discount: 5,
      createdAt: new Date().toISOString(),
    },
    {
      id: 2,
      customerName: 'Sara Khan',
      phone: '0311-9876543',
      items: [{ productId: 3, name: 'Thingamajig C', quantity: 6, price: 5.25 }],
      discount: 0,
      createdAt: new Date().toISOString(),
    },
  ];
  localStorage.setItem(KEY, JSON.stringify(items));
  return items;
}

export function getAll() {
  const raw = localStorage.getItem(KEY);
  if (!raw) return seed();
  try {
    return JSON.parse(raw);
  } catch (e) {
    return seed();
  }
}

export function getById(id) {
  const items = getAll();
  return items.find((o) => o.id === Number(id));
}

function persist(items) {
  localStorage.setItem(KEY, JSON.stringify(items));
}

export function create(order) {
  const items = getAll();
  const nextId = items.length ? Math.max(...items.map((o) => o.id)) + 1 : 1;
  const newItem = { id: nextId, createdAt: new Date().toISOString(), ...order };
  items.push(newItem);
  persist(items);
  return newItem;
}

export function update(id, data) {
  const items = getAll();
  const idx = items.findIndex((o) => o.id === Number(id));
  if (idx === -1) return null;
  items[idx] = { ...items[idx], ...data };
  persist(items);
  return items[idx];
}

export function remove(id) {
  let items = getAll();
  items = items.filter((o) => o.id !== Number(id));
  persist(items);
}

export default { getAll, getById, create, update, remove, computeTotals };
